const BellIcon = () => {
  return (
    <svg
      width="34"
      height="37"
      viewBox="0 0 34 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2686 15.7501C10.2673 14.861 10.442 13.9804 10.7825 13.159C11.123 12.3377 11.6227 11.5918 12.2527 10.9644C12.8828 10.337 13.6307 9.84041 14.4535 9.50329C15.2762 9.16617 16.1575 8.99516 17.0467 9.0001C20.7592 9.02823 23.731 12.1126 23.731 15.8345V16.5001C23.731 19.8564 24.4342 21.8064 25.0529 22.8751C25.1186 22.9889 25.1533 23.118 25.1534 23.2494C25.1535 23.3809 25.1191 23.51 25.0536 23.624C24.9881 23.7379 24.8938 23.8326 24.7801 23.8986C24.6665 23.9647 24.5375 23.9996 24.406 24.0001H9.59355C9.46212 23.9996 9.33312 23.9647 9.21948 23.8986C9.10583 23.8326 9.01153 23.7379 8.94601 23.624C8.8805 23.51 8.84608 23.3809 8.84619 23.2494C8.84631 23.118 8.88096 22.9889 8.94667 22.8751C9.56542 21.8064 10.2686 19.8564 10.2686 16.5001V15.7501Z"
        stroke="#F9F9F9"
        stroke-width="1.375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 24V24.75C14 25.5456 14.3161 26.3087 14.8787 26.8713C15.4413 27.4339 16.2044 27.75 17 27.75C17.7956 27.75 18.5587 27.4339 19.1213 26.8713C19.6839 26.3087 20 25.5456 20 24.75V24"
        stroke="#F9F9F9"
        stroke-width="1.375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="21.3637" cy="11.4545" r="5.45455" fill="#1B1D28" />
      <g filter="url(#filter0_f_12091_4506)">
        <path
          d="M10.2683 15.7501C10.2671 14.861 10.4417 13.9804 10.7823 13.159C11.1228 12.3377 11.6225 11.5918 12.2525 10.9644C12.8825 10.337 13.6305 9.84041 14.4532 9.50329C15.276 9.16617 16.1573 8.99516 17.0464 9.0001C20.7589 9.02823 23.7308 12.1126 23.7308 15.8345V16.5001C23.7308 19.8564 24.4339 21.8064 25.0527 22.8751C25.1184 22.9889 25.153 23.118 25.1532 23.2494C25.1533 23.3809 25.1189 23.51 25.0533 23.624C24.9878 23.7379 24.8935 23.8326 24.7799 23.8986C24.6662 23.9647 24.5372 23.9996 24.4058 24.0001H9.59331C9.46188 23.9996 9.33288 23.9647 9.21923 23.8986C9.10558 23.8326 9.01128 23.7379 8.94577 23.624C8.88025 23.51 8.84583 23.3809 8.84595 23.2494C8.84606 23.118 8.88072 22.9889 8.94643 22.8751C9.56518 21.8064 10.2683 19.8564 10.2683 16.5001V15.7501Z"
          stroke="#F9F9F9"
          stroke-width="1.375"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <g filter="url(#filter1_f_12091_4506)">
        <path
          d="M14 24V24.75C14 25.5456 14.3161 26.3087 14.8787 26.8713C15.4413 27.4339 16.2044 27.75 17 27.75C17.7956 27.75 18.5587 27.4339 19.1213 26.8713C19.6839 26.3087 20 25.5456 20 24.75V24"
          stroke="#F9F9F9"
          stroke-width="1.375"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <circle cx="21.3636" cy="11.4545" r="4.36364" fill="#FF0000" />
      <defs>
        <filter
          id="filter0_f_12091_4506"
          x="0.158447"
          y="0.3125"
          width="33.6821"
          height="32.375"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4"
            result="effect1_foregroundBlur_12091_4506"
          />
        </filter>
        <filter
          id="filter1_f_12091_4506"
          x="5.3125"
          y="15.3125"
          width="23.375"
          height="21.125"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4"
            result="effect1_foregroundBlur_12091_4506"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default BellIcon;
